import {
	ClassNameProps,
	DateTime,
	formatLocaleDateTimeByPrecision,
	isSameTime,
	relativeTime,
	RelativeTimestamp,
	Row,
	StyleProps,
	TruncatedText,
} from "@hex-insights/core";
import { MessageGroupMessagesListQuery } from "../../../../Utilities";
import { UserFormat } from "../../../Format";
import { UserLink } from "../../../Links";
import styles from "./styles.module.css";

export type AuthorTimestampViewProps = {
	author: MessageGroupMessagesListQuery["messageConnection"]["edges"][0]["node"]["author"];
	createdAt: string;
} & Partial<ClassNameProps & StyleProps>;

export function AuthorTimestampView({ author, createdAt, className, style }: AuthorTimestampViewProps) {
	return (
		<Row
			justify="spaced-start"
			align="center"
			horizontalSpacing="0.625rem"
			overflow="wrap"
			className={className}
			style={style}
		>
			<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem" style={{ minWidth: 0 }}>
				<UserLink
					instance={author}
					className={styles["author-timestamp__author-name"] + " link--no-text-decoration"}
					style={{ minWidth: 0 }}
				>
					<TruncatedText>{UserFormat.name(author)}</TruncatedText>
				</UserLink>
			</Row>

			<TruncatedText>
				<RelativeTimestamp
					value={createdAt}
					format={formatMessageTimestamp}
					className={styles["author-timestamp__timestamp"] + " timestamp"}
				/>
			</TruncatedText>
		</Row>
	);
}

function formatMessageTimestamp(value: DateTime) {
	if (isSameTime(value, new Date(), "day")) {
		return relativeTime(value);
	}
	return formatLocaleDateTimeByPrecision(value, "minute");
}
